import React from "react"
import { Board } from "../../components/Board"

export const Kanban = () => {
	return <Board/>	
}
